/**
 * Check if the click event originated from an interactive element
 * that should not trigger row expansion
 */
export function isInteractiveElement(target: EventTarget | null): boolean {
  if (!target || !(target instanceof HTMLElement)) {
    return false;
  }

  // Check for standard interactive elements
  const interactiveTags = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
  const element = target.closest(interactiveTags.join(','));

  return !!element;
}
